import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Loader from 'Elements/Loader';
import { useAppContext } from 'Scenes/_root/appContext';

const EnsureLoggedIn = ({ children, locationPractitionerLogin }) => {
  const { isLoggedIn, isAuthenticating } = useAppContext();
  useEffect(() => {
    if (isLoggedIn || isAuthenticating) {
      return;
    }
    locationPractitionerLogin();
  }, [isLoggedIn, isAuthenticating]);

  if (!isLoggedIn && isAuthenticating) {
    return (
      <Loader />
    );
  }
  return children;
};
EnsureLoggedIn.propTypes = {
  children: PropTypes.node.isRequired,
  locationPractitionerLogin: PropTypes.func.isRequired,
};
export default EnsureLoggedIn;
